import React from "react";
import TrackVisibility from "react-on-screen";
import CountUp from "react-countup";
const CounterFive = () => {
  return (
    <>
      {/* Counter area start */}
      <section className="counter__area-4 line-cols-3 pt-120 pb-100">
        <div className="counter__inner-4 plr-90">
          <div className="counter__list-4">
            <div
              className="counter__item-4"
              data-aos="fade-up"
              data-aos-delay={200}
            >
              <div className="counter__left-4">
              <img src="assets/imgs/about/person-svgrepo-com.svg" alt="Icon" />
              </div>
              <div className="counter__right-4">
                <TrackVisibility once>
                  {({ isVisible }) =>
                    isVisible && (
                      <>
                        <div className="counter__number-4 counter_slow">
                          <CountUp delay={0} start={0} end={100} />+
                        </div>
                        <h2 className="counter__title-4">Müşteri</h2>
                      </>
                    )
                  }
                </TrackVisibility>
              </div>
            </div>
            <div
              className="counter__item-4"
              data-aos="fade-up"
              data-aos-delay={300}
            >
              <div className="counter__left-4">
                <img src="assets/imgs/about/cup-star-svgrepo-com.svg" alt="Icon" />
              </div>
              <div className="counter__right-4">
                <TrackVisibility once>
                  {({ isVisible }) =>
                    isVisible && (
                      <>
                        <div className="counter__number-4 counter_slow">
                          <CountUp delay={0} start={0} end={25} />
                          +
                        </div>
                        <h2 className="counter__title-4">Yıllık Tecrübe</h2>
                      </>
                    )
                  }
                </TrackVisibility>
              </div>
            </div>
            <div
              className="counter__item-4"
              data-aos="fade-up"
              data-aos-delay={400}
            >
              <div className="counter__left-4">
              <img src="assets/imgs/about/education-cap-svgrepo-com.svg" alt="Icon" />
                
              </div>
              <div className="counter__right-4">
                <TrackVisibility once>
                  {({ isVisible }) =>
                    isVisible && (
                      <>
                        <div className="counter__number-4 counter_slow">
                          <CountUp delay={0} start={0} end={8} />+
                        </div>
                        <h2 className="counter__title-4">Eğitim Türü</h2>
                      </>
                    )
                  }
                </TrackVisibility>
              </div>
            </div>
            <div
              className="counter__item-4"
              data-aos="fade-up"
              data-aos-delay={500}
            >
              <div className="counter__left-4">
                <img src="assets/imgs/about/map-location-pin-svgrepo-com.svg" alt="Icon" />
              </div>
              <div className="counter__right-4">
                <TrackVisibility once>
                  {({ isVisible }) =>
                    isVisible && (
                      <>
                        <div className="counter__number-4 counter_slow">
                          <CountUp delay={0} start={0} end={9} />+
                        </div>
                        <h2 className="counter__title-4">Farklı Ülkede</h2>
                      </>
                    )
                  }
                </TrackVisibility>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Counter area end */}
    </>
  );
};

export default CounterFive;
